import { Component, OnInit, ViewChild, ElementRef, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { EdpModalService } from "@edp-components/edp-modal";
import { Contract } from "@edp-components/edp-contract";
import { ActiveMeters, IMeterTypes, Meters } from "../edp-consumptions.models";
import { MeterType } from "@edp-enums/meter-type.enum";
import { getActiveMetersElectricity, getMeterInstructions } from "@edp-store/selectors/dashboard.selectors";
import { GetMeterInstructions } from "@edp-store/actions/dashboard.actions";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { environment } from "@edp-environments/environment";
import { DeviceDetectorService } from "ngx-device-detector";

@Component({
  selector: "app-edp-widget-consumptions-support",
  templateUrl: "./edp-widget-consumptions-support.component.html",
  styleUrls: ["./edp-widget-consumptions-support.component.scss"]
})
export class EdpWidgetConsumptionsSupportComponent implements OnInit, OnDestroy {

    @ViewChild("meterList", {read: ElementRef, static: false}) meterList: ElementRef;
    @ViewChild("steps", {read: ElementRef, static: false}) steps: ElementRef;

    public isSwipe: boolean;
    public slideConfig: object = {};
    public highlightedMeterIndex = null;
    public meter = null;
    public allMeters = [];
    public contract: Contract = null;
    public activeMetersElectricity: ActiveMeters;
    public meterInstructionsLoaded = false;
    public canChange = false;
    public openedKeyboard = false;
    public isApp = false;
    public isAppiOS = false;

    private unsubscribe = new Subject();
    private contractMeterType;
    private showMetersListTypes = [MeterType.ESTATICO];

    constructor(
        private edpModalService: EdpModalService,
        private store: Store<IAppState>,
        private changeDetector: ChangeDetectorRef,
        private deviceDetector: DeviceDetectorService
    ) { }

    ngOnInit() {
        this.isApp = environment.isApp;
        this.isAppiOS = environment.isApp && this.deviceDetector.device === "iPhone";

        this.store.pipe(
            takeUntil(this.unsubscribe),
            select(getContract)
        ).subscribe(contract => {
            if (contract) {
                this.contract = contract;
            }
        });

        this.store.pipe(
            takeUntil(this.unsubscribe),
            select(getActiveMetersElectricity)
        ).subscribe((activeMeters: ActiveMeters[]) => {
            if (!!activeMeters && activeMeters.length) {
                this.activeMetersElectricity = activeMeters[0];
                this.checkMeterType(activeMeters[0]);
            }
        });

        this.store.pipe(
            takeUntil(this.unsubscribe),
            select(getMeterInstructions)
            ).subscribe((instructions: IMeterTypes) => {
                if (instructions) {
                    const meterInstructions =
                        this.contractMeterType === MeterType.INTELIGENTE ? instructions.ModelTypes.INTELIGENTE :
                        this.contractMeterType === MeterType.ELECTROMECANICO ? instructions.ModelTypes.ELECTROMECANICO :
                        this.contractMeterType === MeterType.ESTATICO ? instructions.ModelTypes.ESTATICO :
                        null;

                    if (!meterInstructions && meterInstructions.length === 0) {
                        return;
                    }
                    this.meterInstructionsLoaded = true;

                    if (!this.showMetersListTypes.includes(this.contractMeterType)) {
                        this.canChange = false;
                        this.meter = {
                            selected: true,
                            type: meterInstructions[0].Attributes.Type,
                            modelDescription: meterInstructions[0].Attributes.Description,
                            shortModelDescription: meterInstructions[0].Attributes.Description,
                            picture: meterInstructions[0].Attributes.Picture,
                            step1: meterInstructions[0].Instructions.Mobile.Vazio,
                            step2: meterInstructions[0].Instructions.Mobile.Ponta,
                            step3: meterInstructions[0].Instructions.Mobile.Cheia,
                        };
                        this.showMeter1stStep();
                    } else {
                        this.canChange = true;
                        meterInstructions.forEach(meterModel => {
                            this.allMeters.push({
                                selected: false,
                                type: meterModel.Attributes.Type,
                                modelDescription: meterModel.Attributes.Description,
                                shortModelDescription: meterModel.Attributes.Description,
                                picture: meterModel.Attributes.Picture,
                                step1: meterModel.Instructions.Mobile.Vazio,
                                step2: meterModel.Instructions.Mobile.Ponta,
                                step3: meterModel.Instructions.Mobile.Cheia,
                            });
                        });
                    }
                } else {
                    this.store.dispatch(new GetMeterInstructions());
                }
            });

        this.slideConfig = {
            slidesToShow: 4.1,
            slidesToScroll: 2,
            dots: false,
            infinite: false,
            autoplay: false,
            arrows: false,
            variableWidth: true,
            centerMode: false,
            focusOnSelect: false,
            responsive: [
                {
                breakpoint: 1024,
                    settings: {
                        slidesToShow: 3.2,
                        centerMode: true,
                    }
                },
                {
                breakpoint: 768,
                    settings: {
                        slidesToShow: 2.3,
                        centerMode: true,
                    }
                },
                {
                breakpoint: 552,
                    settings: {
                        slidesToShow: 1.4,
                        centerMode: true,
                    }
                }
            ]
        };
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    public onHighligthMeter(event: any, meter: any, index: number) {
        if (this.highlightedMeterIndex === index) {
            meter.selected = false;
            this.highlightedMeterIndex = null;
        } else {
            if (this.highlightedMeterIndex !== null) {
                this.clearHighlighting();
            }
            meter.selected = true;
            this.highlightedMeterIndex = index;
        }
    }

    public focusMeter(focusMeter: Meters) {
        this.openedKeyboard = true;
        const htmlElement = this.steps.nativeElement;
        if (focusMeter) {
            switch (focusMeter.RegisterType) {
                case "V": htmlElement.innerHTML = this.meter.step1;
                          break;
                case "P": htmlElement.innerHTML = this.meter.step2;
                          break;
                case "C": htmlElement.innerHTML = this.meter.step3;
                          break;
                case "S": htmlElement.innerHTML = this.meter.step1;
                          break;
                case "FV": htmlElement.innerHTML = this.meter.step2;
                           break;
                default: htmlElement.innerHTML = this.meter.step1;
                         break;
            }
        }
    }

    public blurMeter() {
        this.openedKeyboard = false;
    }

    public onSelectMeter() {
        this.meter = this.allMeters[this.highlightedMeterIndex];
        this.showMeter1stStep();
    }

    public onDeselectMeter() {
        this.meter = null;
        this.allMeters[this.highlightedMeterIndex].selected = false;
        this.highlightedMeterIndex = null;
    }

    public beforeChange(e) {
        this.isSwipe = true;
    }

    public afterChange(e) {
        this.isSwipe = false;
    }

    public onSubmitted(event: any) {
        this.edpModalService.close(event);
    }

    public dismiss(): void {
        this.edpModalService.close(false);
    }

    private checkMeterType(activeMeters: ActiveMeters) {
        if (activeMeters.lastInserted.telemetry === "Y") {
            this.contractMeterType = MeterType.INTELIGENTE ;
        } else {
            this.contractMeterType = activeMeters.meters[0].Material;
        }
    }

    private clearHighlighting() {
        this.highlightedMeterIndex = null;
        const selectClassName = "meter-item-selected";
        const listHtmlMeters = Array.from(this.meterList.nativeElement.children[0].children[0].children);
        listHtmlMeters.forEach((childHtmlMeter: HTMLElement, index) => {
            if (childHtmlMeter.children[0].classList.contains(selectClassName)) {
                childHtmlMeter.children[0].classList.remove(selectClassName);
                this.allMeters[index].selected = false;
            }
        });
    }

    private detectChanges() {
        this.changeDetector.detectChanges();
    }

    private showMeter1stStep() {
        this.detectChanges();
        this.steps.nativeElement.innerHTML = this.meter.step1;
    }
}
